import { v4 as uuid } from 'uuid';
import { getEncodedHostRedirectUrl } from './utils/urlEncoding';
var timeoutMsg = 'OAuth session timeout';
export var invalidLengthMsg = 'Authorization code exceeds max length of 2048 characters';
export var invalidCharactersMsg = 'Authorization code contains unexpected characters. Allowed characters are a-z, A-Z, 0-9, ., _, +, /, =, ~, and -';
var defaultTimeout = 120000;
var oauthRedirectMethodPlaceholder = '{oauthRedirectMethod}';
var deeplinkRedirectMethodName = 'deeplink';
var authIdPlaceholder = '{authId}';
export var authIdParamName = 'authId';
var hostRedirectUrlPlaceholder = '{hostRedirectUrl}';
export var resultParamName = 'result';
export var resultParamPlaceholder = '{result}';
// Regex to validate that the auth result is a string that contains only valid characters: a-z, A-Z, 0-9, ., _, +, /, =, ~, and -
// Invalid strings such as '<result>' or '$result' will throw an error when calling completeAuth
var validResultRegex = '^[-a-zA-Z0-9._~+/=]+$';
var getAuthIdFromUrl = function (url) {
    var authId = new URL(url).searchParams.get(authIdParamName);
    return authId && authId !== authIdPlaceholder ? authId : uuid();
};
var createExternalAuthService = function () {
    var authSessions = {};
    return {
        startAuth: function (url, handler, hostRedirectUrl) {
            // auth session ID
            var authId = getAuthIdFromUrl(url);
            // URL is validated in HostedWebContentAuthSdkService before calling startAuth
            url = url
                .replace(oauthRedirectMethodPlaceholder, deeplinkRedirectMethodName)
                .replace(authIdPlaceholder, authId)
                .replace(hostRedirectUrlPlaceholder, hostRedirectUrl ? getEncodedHostRedirectUrl(hostRedirectUrl, authId) : '');
            authSessions[authId] = {
                handler: handler,
                url: url,
                timeoutId: window.setTimeout(function () {
                    handler(false, timeoutMsg);
                    delete authSessions[authId];
                }, defaultTimeout),
            };
            return url;
        },
        completeAuth: function (authId, result) {
            // Validate that authId and result are strings since data is passed from the browser
            if (typeof authId === 'string' && typeof result === 'string') {
                var session = authSessions[authId];
                if (session) {
                    window.clearTimeout(session.timeoutId);
                    var accessTokenRegex = RegExp(validResultRegex);
                    if (result.length > 2048) {
                        // result exceeds max length
                        session.handler(false, invalidLengthMsg);
                    }
                    else if (accessTokenRegex.test(result)) {
                        // valid result
                        session.handler(true, result);
                    }
                    else {
                        // result contains invalid characters
                        session.handler(false, invalidCharactersMsg);
                    }
                    delete authSessions[authId];
                }
            }
        },
    };
};
export var externalAuthService = createExternalAuthService();
//# sourceMappingURL=external-auth-service.js.map